module.exports = __webpack_public_path__ + "static/media/iconfinder-basics-22-296812.1f826177.svg";